import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Secure.module.scss';

export const SecureStepThree = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.secureLeftSection}>
        <span className={styles.secureStepLeft_1}>Secure Data with</span>
        <span className={styles.secureStepLeft_2}>FCE</span>
        <span className={styles.secureStepLeft_3}>Blockchain</span>
        <span className={styles.secureStepLeft_4}>and</span>
        <span className={styles.secureStepLeft_5}>Tokenization</span>
      </div>
    }
    rightContent={
      <div className={styles.secureStepContentWrapper}>
        <p style={{ marginBottom: 40 }}>
          <div style={{ marginBottom: 8, fontWeight: 600 }}> Verification of user data</div>
          Business depends on data. Fast and accurate data acquisition is crucial. Blockchain makes
          the identification and exchange of data provided by a client or a company secure, records
          the facts of the data transfer, and acts as a guarantor.
        </p>
        <p>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>
            Notarization of documents and certificates
          </div>
          Remote interaction with documents is impossible without verification and notarization of
          documents. Blockchain fixes terms and conditions and ensures that every collaboration is
          secure and trustable. Thanks to the blockchain, no one can change your agreements, and
          sensitive data will remain closed.
        </p>
      </div>
    }
  />
);
